var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 450",
    style: {
      enableBackground: "new 0 0 512 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.6,411L274.2,19c-11.1-16.9-32.3-9.1-36.5,0L13,413c-7.7,15.8,8,26.4,18.3,25.9h449.2c0.1,0,0.1,0,0.2,0 C496.8,439.7,506.5,422.9,497.6,411z M64.3,403.2L255.9,67.1l191.6,336.1H64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.5,177.7v110.5c0,9.9,9.1,17.9,20.4,17.9s20.4-8,20.4-17.9V177.7c0-9.9-9.1-17.9-20.4-17.9 C244.6,159.8,235.5,167.8,235.5,177.7L235.5,177.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 255.9,
    cy: 351.2,
    rx: 20.5,
    ry: 20.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fda7f340db806fb43da097538c08307d.svg";
export { ForwardRef as ReactComponent };